import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=57c645f5&scoped=true&"
import script from "./Request.vue?vue&type=script&lang=js&"
export * from "./Request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c645f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c645f5')) {
      api.createRecord('57c645f5', component.options)
    } else {
      api.reload('57c645f5', component.options)
    }
    module.hot.accept("./Request.vue?vue&type=template&id=57c645f5&scoped=true&", function () {
      api.rerender('57c645f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/recursos/Request.vue"
export default component.exports